import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 py-16 sm:py-20 text-center" }
const _hoisted_2 = { class: "mt-6 text-slate-600 font-medium" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingState',
  props: {
    message: { default: "Cargando…" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "inline-block relative" }, [
      _createElementVNode("div", {
        class: "w-14 h-14 border-4 border-red-100 border-t-red-600 rounded-full animate-spin",
        "aria-hidden": "true"
      })
    ], -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.message), 1)
  ]))
}
}

})